import { render, staticRenderFns } from "./PlaceHolder.vue?vue&type=template&id=13060355&scoped=true"
import script from "./PlaceHolder.vue?vue&type=script&lang=js"
export * from "./PlaceHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13060355",
  null
  
)

export default component.exports